import { useFeatureGates } from '@office-start/feature-gates-service';
import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import { IDLE_LOW_PRIORITY, IDLE_VERYLOW_PRIORITY, } from '@office-start/scheduler-service';
import React, { lazy, useMemo } from 'react';
export var Banner = function () {
    var _a, _b;
    var isIdleVeryLowPriorityLoad = ((_b = (_a = useFeatureGates().data) === null || _a === void 0 ? void 0 : _a.result.idleVeryLowPriorityLoadGates) === null || _b === void 0 ? void 0 : _b.idleVeryLowPriorityLoadEnabled) || false;
    var BannerComponentLazy = useMemo(function () {
        return withLazyErrorBoundary(lazy(function () {
            return import(/* webpackChunkName: "banner" */ './LazyBanner');
        }), 'Banner', {
            schedulePriority: isIdleVeryLowPriorityLoad
                ? IDLE_VERYLOW_PRIORITY
                : IDLE_LOW_PRIORITY,
        });
    }, []);
    return React.createElement(BannerComponentLazy, null);
};
//# sourceMappingURL=Banner.js.map